export const GET_LANDING_NFTS_REQUEST = 'GET_LANDING_NFTS_REQUEST';
export const GET_LANDING_NFTS_SUCCESS = 'GET_LANDING_NFTS_SUCCESS';
export const GET_LANDING_NFTS_FAILURE = 'GET_LANDING_NFTS_FAILURE';

export const GET_NFT_MINTED_REQUEST = 'GET_NFT_MINTED_REQUEST';
export const GET_NFT_MINTED_SUCCESS = 'GET_NFT_MINTED_SUCCESS';
export const GET_NFT_MINTED_FAILURE = 'GET_NFT_MINTED_FAILURE';

export const GET_NFT_OWNERS_REQUEST = 'GET_NFT_OWNERS_REQUEST';
export const GET_NFT_OWNERS_SUCCESS = 'GET_NFT_OWNERS_SUCCESS';
export const GET_NFT_OWNERS_FAILURE = 'GET_NFT_OWNERS_FAILURE';

export const GET_OWNED_LANDING_NFTS_REQUEST = 'GET_OWNED_LANDING_NFTS_REQUEST';
export const GET_OWNED_LANDING_NFTS_SUCCESS = 'GET_OWNED_LANDING_NFTS_SUCCESS';
export const GET_OWNED_LANDING_NFTS_FAILURE = 'GET_OWNED_LANDING_NFTS_FAILURE';
